import Axios from "../../../axios";
import {activityApiConstants} from "../../../constants/ApiConstant";

export async function searchActivities({userId, schoolId, page, size}) {
    const params = {page, size};

    if (userId) params.userId = userId;
    if (schoolId) params.schoolId = schoolId;

    return Axios.get(activityApiConstants.SEARCH_ACTIVITIES, {params});
}
